import {ko} from '../knockout-global';
// @ts-expect-error knockout-switch-case ships UMD without ESM types
import registerSwitchCase from 'knockout-switch-case/knockout-switch-case.js';

registerSwitchCase(ko);
